import * as Turbo from "@hotwired/turbo";
import { Application } from "@hotwired/stimulus";
import TimeagoController from "./controllers/ui/timeago_controller.js";
import DialogController from "./controllers/ui/dialog_controller.js";
import ClipboardController from "./controllers/ui/clipboard_controller.js";
import ModActionController from "./controllers/mod/mod_action_controller.js";
import ObsAudioController from "./controllers/stream/obs_audio_controller.js";
import ObsSceneController from "./controllers/stream/obs_scene_controller.js";
import AdapterStatusController from "./controllers/admin/adapter_status_controller.js";
import ChatAutoscrollController from "./controllers/stream/chat_autoscroll_controller.js";
import DashboardCanvasController from "./controllers/stream/dashboard_canvas_controller.js";
import DashboardHeightController from "./controllers/stream/dashboard_height_controller.js";
import PanelCollapseController from "./controllers/ui/panel_collapse_controller.js";
import PanelSettingsController from "./controllers/stream/panel_settings_controller.js";
import DropdownController from "./controllers/ui/dropdown_controller.js";
import FlashController from "./controllers/ui/flash_controller.js";
import AccordionController from "./controllers/ui/accordion_controller.js";
import GameSearchController from "./controllers/stream/game_search_controller.js";
import CategoryPickerController from "./controllers/stream/category_picker_controller.js";
import SessionNotesController from "./controllers/stream/session_notes_controller.js";
import ViewerChartController from "./controllers/analytics/viewer_chart_controller.js";
import CountUpController from "./controllers/ui/count_up_controller.js";
import AnalyticsEntranceController from "./controllers/analytics/analytics_entrance_controller.js";
import WordCloudController from "./controllers/stream/word_cloud_controller.js";
import CommandPaletteController from "./controllers/ui/command_palette_controller.js";
import SidebarController from "./controllers/ui/sidebar_controller.js";
import DirtyFormController from "./controllers/ui/dirty_form_controller.js";
import AutosaveController from "./controllers/ui/autosave_controller.js";
import UrlValidatorController from "./controllers/ui/url_validator_controller.js";
import TitleTemplateController from "./controllers/stream/title_template_controller.js";
import TitleTemplatesAdminController from "./controllers/admin/title_templates_admin_controller.js";
import CharCounterController from "./controllers/ui/char_counter_controller.js";
import ChatPinController from "./controllers/stream/chat_pin_controller.js";
import MarkdownPreviewController from "./controllers/ui/markdown_preview_controller.js";
import EmbedBuilderController from "./controllers/admin/embed_builder_controller.js";
import DiscordInviteController from "./controllers/discord/discord_invite_controller.js";
import OnboardingController from "./controllers/onboarding/onboarding_controller.js";
import PushNotificationController from "./controllers/ui/push_notification_controller.js";
import AutoOpenController from "./controllers/ui/auto_open_controller.js";
import PostLinkController from "./controllers/admin/post_link_controller.js";
import MessageEditorController from "./controllers/discord/message_editor_controller.js";
import TemplatePickerController from "./controllers/discord/template_picker_controller.js";
import CommandBulkSelectController from "./controllers/discord/command_bulk_select_controller.js";
import ScreeningFiltersController from "./controllers/mod/screening_filters_controller.js";
import RoleConnectionsController from "./controllers/discord/role_connections_controller.js";
import UserRoleOverridesController from "./controllers/mod/user_role_overrides_controller.js";
import ReactionRolesAdminController from "./controllers/discord/reaction_roles_admin_controller.js";
import AppealFormBuilderController from "./controllers/mod/appeal_form_builder_controller.js";
import InlineCrudController from "./controllers/ui/inline_crud_controller.js";
import ReportThresholdsController from "./controllers/discord/report_thresholds_controller.js";
import TabsController from "./controllers/ui/tabs_controller.js";
import ScheduleFormController from "./controllers/schedule/schedule_form_controller.js";
import ReminderPrefController from "./controllers/schedule/reminder_pref_controller.js";
import ReminderOverrideController from "./controllers/schedule/reminder_override_controller.js";
import ScheduleViewController from "./controllers/schedule/schedule_view_controller.js";
import ScheduleMonthController from "./controllers/schedule/schedule_month_controller.js";
import PlatformPickerController from "./controllers/onboarding/platform_picker_controller.js";
import InfractionFilterController from "./controllers/mod/infraction_filter_controller.js";
import ReasonAliasesAdminController from "./controllers/mod/reason_aliases_admin_controller.js";
import ConfirmTextController from "./controllers/ui/confirm_text_controller.js";
import ResolutionNoteController from "./controllers/mod/resolution_note_controller.js";
import InviteCodeController from "./controllers/onboarding/invite_code_controller.js";

window.Turbo ||= Turbo;

// Close a <dialog> element by id — used by Turbo Stream responses from
// form submissions inside config dialogs.
Turbo.StreamActions.closeDialog = function () {
  this.targetElements.forEach((el) => el.close());
};

const application = Application.start();
application.register("timeago", TimeagoController);
application.register("dialog", DialogController);
application.register("clipboard", ClipboardController);
application.register("mod-action", ModActionController);
application.register("obs-audio", ObsAudioController);
application.register("obs-scene", ObsSceneController);
application.register("adapter-status", AdapterStatusController);
application.register("chat-autoscroll", ChatAutoscrollController);
application.register("dashboard-canvas", DashboardCanvasController);
application.register("dashboard-height", DashboardHeightController);
application.register("panel-collapse", PanelCollapseController);
application.register("panel-settings", PanelSettingsController);
application.register("dropdown", DropdownController);
application.register("flash", FlashController);
application.register("accordion", AccordionController);
application.register("game-search", GameSearchController);
application.register("category-picker", CategoryPickerController);
application.register("session-notes", SessionNotesController);
application.register("viewer-chart", ViewerChartController);
application.register("count-up", CountUpController);
application.register("analytics-entrance", AnalyticsEntranceController);
application.register("word-cloud", WordCloudController);
application.register("command-palette", CommandPaletteController);
application.register("sidebar", SidebarController);
application.register("dirty-form", DirtyFormController);
application.register("autosave", AutosaveController);
application.register("url-validator", UrlValidatorController);
application.register("title-template", TitleTemplateController);
application.register("title-templates-admin", TitleTemplatesAdminController);
application.register("char-counter", CharCounterController);
application.register("chat-pin", ChatPinController);
application.register("markdown-preview", MarkdownPreviewController);
application.register("embed-builder", EmbedBuilderController);
application.register("discord-invite", DiscordInviteController);
application.register("onboarding", OnboardingController);
application.register("push-notification", PushNotificationController);
application.register("auto-open", AutoOpenController);
application.register("post-link", PostLinkController);
application.register("message-editor", MessageEditorController);
application.register("template-picker", TemplatePickerController);
application.register("command-bulk-select", CommandBulkSelectController);
application.register("screening-filters", ScreeningFiltersController);
application.register("role-connections", RoleConnectionsController);
application.register("user-role-overrides", UserRoleOverridesController);
application.register("reaction-roles-admin", ReactionRolesAdminController);
application.register("appeal-form-builder", AppealFormBuilderController);
application.register("inline-crud", InlineCrudController);
application.register("report-thresholds", ReportThresholdsController);
application.register("tabs", TabsController);
application.register("schedule-form", ScheduleFormController);
application.register("reminder-pref", ReminderPrefController);
application.register("reminder-override", ReminderOverrideController);
application.register("schedule-view", ScheduleViewController);
application.register("schedule-month", ScheduleMonthController);
application.register("platform-picker", PlatformPickerController);
application.register("infraction-filter", InfractionFilterController);
application.register("reason-aliases-admin", ReasonAliasesAdminController);
application.register("confirm-text", ConfirmTextController);
application.register("resolution-note", ResolutionNoteController);
application.register("invite-code", InviteCodeController);

// Active-link sync for Turbo Frame navigations (data-turbo-frame="main-content").
// Frame navigations don't re-render the sidebar, so active state is updated here.
function syncSidebarActiveLinks() {
  const sidebar = document.getElementById("sc-sidebar");
  if (!sidebar) return;
  const path = window.location.pathname;
  sidebar.querySelectorAll("[data-sidebar-href]").forEach((el) => {
    const href = el.dataset.sidebarHref;
    const exact = el.dataset.sidebarExact === "true";
    const isActive = !!href && (path === href || (!exact && path.startsWith(href + "/")));
    el.classList.toggle("active", isActive);
    if (isActive) {
      el.setAttribute("aria-current", "page");
    } else {
      el.removeAttribute("aria-current");
    }
  });
}
document.addEventListener("turbo:load", syncSidebarActiveLinks);
document.addEventListener("turbo:frame-load", (e) => {
  if (e.target.id === "main-content") syncSidebarActiveLinks();
});
